export default "__VITE_ASSET__DXgEA7ae__"